import React from "react";
import { CourseValidationError } from "src/types/coaching/courses";

export interface SelectedItem {
  id: string;
  type: "lesson" | "podcast" | "simulation";
  title?: string;
}

export interface CourseContextProps {
  id?: string;
  courseContent?: any;
  preferences?: any;
  validationError?: CourseValidationError;
  
  showValidationErrorDialog?: boolean;
  
  // eslint-disable-next-line no-unused-vars
  setShowValidationErrorDialog?: (show: boolean) => void;

  // eslint-disable-next-line no-unused-vars
  gotoError(error?: CourseValidationError): void;
  
  // eslint-disable-next-line no-unused-vars
  updatePreferences?: (preferences: any) => void;
  selected?: any;
  setSelected?: any;
  selectedSectionId?: string | null;
  setSelectedSectionId?: (id: string | null) => void;
  onContentTypeSelect?: (parentSectionId?: string | null) => void;
  showAssetsDialog: boolean;
  setShowAssetDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CourseContext = React.createContext<CourseContextProps>({
  gotoError: () => {},
  selected: [],
  setSelected: () => {},
  showAssetsDialog: false,
  setShowAssetDialog: () => {},
});
